export default "__VITE_ASSET__C2vkS_j$__"